import React from 'react';
import './Css/Awards.css';
import Footer from './Essentials/Footer';
import Navbar from './Essentials/Navbar';
import { useLocation } from 'react-router-dom';

const Awards = () => {
    const { pathname } = useLocation();
    const isNfrac = pathname.replace("/", "") === "nfrac_awards" && window.innerWidth > 750;
    const awardsData = [
        {
            id: 1,
            date: 'Feb 01, 2020',
            title: 'Excellence award for Artificial Intelligence Project (RONY)',
            img: 'awardOne.png',
            desc: 'Introducing Rony, a virtual robot that mimics human behavior and understands voice commands. Created an interface with zero human-machine physical interaction, pushing the boundaries of AI enhancement.'
        },
        {
            id: 2,
            date: 'Feb 15, 2020',
            title: 'Excellence award for GPA Calculator Project',
            img: 'awardTwo.png',
            desc: 'A milestone project supported by family and mentors. This token of gratitude represents the technical journey and the confidence gained through consistent mentorship.'
        },
        {
            id: 3,
            date: 'Sep 17, 2021',
            title: '"Malla Reddy Institute of Technology" Official App',
            img: 'awardThree.png',
            desc: 'Successfully launched "The MRIT App" after a year of development. Designed to be user-friendly for the campus crew, providing essential tools and information for the college community.'
        },
        {
            id: 4,
            date: 'Dec 08, 2021',
            title: 'Best Innovative Idea Award',
            img: 'awardFour.jpg',
            desc: 'Received recognition for "Best Innovative Ideology" at CIRDL. This award honors the process of taking raw ideas and executing them into functional, real-world solutions.'
        },
        {
            id: 5,
            date: 'Dec 30, 2021',
            title: 'Appreciation of Holistic Performance',
            img: 'awardFive.png',
            desc: 'A recognition of over 77 completed projects. This award highlights the potential and manifestation of technical skills across various domains within the collegiate environment.'
        }
    ];

    return (
        <div className={`page-wrapper ${isNfrac ? 'nfrac-theme' : ''}`}>
            <Navbar />

            <main id="awards" className="Awards-container">
                <header className="awards-header">
                    <h1>Awards & Recognition</h1>
                </header>

                <div className="awards-list">
                    {awardsData.map((award, key) => (
                        <section className="award-card" key={key}>
                            <div className="award-content">
                                <div className="award-text">
                                    <span className="award-date">{award.date}</span>
                                    <h2>{award.title}</h2>
                                    <p>{award.desc}</p>
                                </div>
                                <div className="award-image-wrapper">
                                    <img
                                        src={`projects/${award.img}`}
                                        alt={award.title}
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </section>
                    ))}

                    {/* Newspaper Highlight Card */}
                    <section className="award-card news-section">
                        <div className="award-content">
                            <div className="award-text">
                                <span className="award-date">Sep 18, 2021</span>
                                <h2>Featured in Enadu Newspaper</h2>
                                <p>It was a great honor to be featured in Enadu's newspaper, recognizing technical contributions and project milestones.</p>
                            </div>
                            <div className="award-image-wrapper">
                                <img id="newsPaper" src="projects/EnaduPaper.png" alt="Enadu Newspaper Feature" />
                            </div>
                        </div>
                    </section>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Awards;